import React, { useState, useEffect, useRef, useMemo } from "react";
import {
	Chart as ChartJS,
	CategoryScale,
	LinearScale,
	BarElement,
	Title,
	Tooltip,
	Legend,
} from "chart.js";
import { Bar } from "react-chartjs-2";
import {
	obtenerDatos,
	obtenerEdadIniciaRetiro,
	obtenerEdadFinRetiro,
} from "../../../functions/Datos";
import { bgColor } from "../../../functions/constants";
import { getClientDependants } from "../../../functions/DependantsQueries";
import { showClient } from "../../../functions/ClientsQueries";

ChartJS.register(
	CategoryScale,
	LinearScale,
	BarElement,
	Title,
	Tooltip,
	Legend
);

export default function Grafica({ cliente_id }) {
	const [datos, setDatos] = useState();
	const [edadInicioRetiro, setEdadInicioRetiro] = useState();
	const [edadFinRetiro, setEdadFinRetiro] = useState();
	const [porcentaje, setPorcentaje] = useState(0);
	const [dependientes, setDependientes] = useState([]);
	const [cliente, setCliente] = useState({});
	const titleRef = useRef(null);

	let fondo_previsto_retiro_acumulado = useMemo(() => [], []);
	let fondo_retiro_no_previsto = useMemo(() => [], []);

	let anos = [];
	// let edad = [];
	let texto = [];
	let contador = 0;



	if (datos !== undefined) {
		// Ciclo nombres
		datos.forEach((element) => {
			if (
				element.edad_titular >= edadInicioRetiro &&
				element.edad_titular <= edadFinRetiro
			) {
				fondo_previsto_retiro_acumulado.push(
					element.fondo_previsto_retiro_acumulado
				);
				fondo_retiro_no_previsto.push(element.fondo_retiro_no_previsto);
				// anos.push([element.ano, `${element.edad_titular}`])
				console.log("fondo_previsto_retiro_acumulado", element.fondo_previsto_retiro_acumulado)
				console.log("fondo_retiro_no_previsto", element.fondo_retiro_no_previsto)

				if (contador === 0) {
					texto.push(`${cliente.nombre}`);
					dependientes?.forEach((e) => {
						texto.push(`${e.nombre}`);
					});
					contador++;
				}
			}
		});

		// Ciclo años y edades
		let hijo_1 = datos[0].edad_hijo_1 ? datos[0].edad_hijo_1 : "";
		let hijo_2 = datos[0].edad_hijo_2 ? datos[0].edad_hijo_2 : "";
		let hijo_3 = datos[0].edad_hijo_3 ? datos[0].edad_hijo_3 : "";
		let hijo_4 = datos[0].edad_hijo_4 ? datos[0].edad_hijo_4 : "";
		datos.forEach((element) => {
			if (
				element.edad_titular >= edadInicioRetiro &&
				element.edad_titular <= edadFinRetiro
			) {
				let arr = [element.ano];
				element.edad_titular && arr.push(`${element.edad_titular}`);
				element.edad_conyuge && arr.push(`${element.edad_conyuge}`);
				anos.push(arr);
				hijo_4 && arr.push(hijo_4++);
				hijo_3 && arr.push(hijo_3++);
				hijo_2 && arr.push(hijo_2++);
				hijo_1 && arr.push(hijo_1++);
			}
		});
	}
	// console.log({ datos });

	const scrollToTitle = () => {
		setTimeout(() => {
			titleRef.current?.scrollIntoView({ behavior: "smooth" });
		}, 2000);
	};

	useEffect(() => {
		obtenerDatos(cliente_id, setDatos);
		obtenerEdadIniciaRetiro(cliente_id, setEdadInicioRetiro);
		obtenerEdadFinRetiro(cliente_id, setEdadFinRetiro);
		getClientDependants(cliente_id, setDependientes);
		showClient(cliente_id, setCliente);
		scrollToTitle();
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, []);

	useEffect(() => {
		if (
			typeof fondo_previsto_retiro_acumulado !== "undefined" &&
			fondo_previsto_retiro_acumulado !== null &&
			fondo_previsto_retiro_acumulado.length !== 0 &&
			typeof fondo_retiro_no_previsto !== "undefined" &&
			fondo_retiro_no_previsto !== null &&
			fondo_retiro_no_previsto.length !== 0
		) {
			let a = fondo_previsto_retiro_acumulado[0];
			let b = fondo_retiro_no_previsto[0];
			let porc = (100 - (a / (a + b)) * 100).toFixed(2);
			setPorcentaje(porc);
		}
	}, [fondo_previsto_retiro_acumulado, fondo_retiro_no_previsto]);

	const options = {
		plugins: {
			legend: {
				position: "bottom",
			},
			title: {
				display: false,
				text: "Stacked 3",
			},
			datalabels: {
				display: false,
			},
		},
		responsive: true,
		scales: {
			x: {
				stacked: true,
				grid: {
					display: false,
				},
				title: {
					display: true,
					text: texto,
				},
			},
			y: {
				stacked: true,
			},
		},
	};

	const labels = anos;

	const data = {
		labels,
		datasets: [
			{
				label: "Fondo previsto para Retiro",
				data: fondo_previsto_retiro_acumulado,
				backgroundColor: bgColor[0],
			},
			{
				label: "Retiro Aún No Previsto",
				data: fondo_retiro_no_previsto,
				backgroundColor: bgColor[10],
			},
		],
	};

	return (
		<div className="px-4 py-5 mx-4 bg-white shadow sm:rounded-lg sm:p-6">
			<div className="text-sm font-bold text-center sm:text-2xl">
				Fondos Retiro Necesarios vs Previstos
				{porcentaje ? (
					<>
						<div className="mr-20 text-right">
							<button className="p-2 mt-4 -mb-2 text-lg font-bold bg-gray-300 border-2 border-red-500 rounded-xl sm:text-md">
								{porcentaje} % aún no previsto
							</button>
						</div>
					</>
				) : null}
			</div>
			<div className="overflow-hidden">
				<div className="flex flex-col">
					<div className="-my-2 overflow-x-auto sm:-mx-6 lg:-mx-8">
						<div className="inline-block min-w-full py-2 align-middle sm:px-6 lg:px-8">
							<div className="flex flex-col items-center mt-6">
								<div className="flex justify-center w-11/12 p-4 mb-8 rounded-lg shadow-xl">
									{typeof datos === "undefined" ||
										datos === null ||
										datos.length === 0 ? null : (
										<Bar data={data} options={options} />
									)}
								</div>
								<br />
							</div>
						</div>
					</div>
				</div>
				<div ref={titleRef} />
			</div>
		</div>
	);
}
